export default "__VITE_ASSET__k4r71NqB__"